
  import { defineComponent, onMounted, watch, getCurrentInstance } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { Mutations } from '@/store/enums/StoreEnums';
  import LTRLayout from '@/layout/direction/LTRLayout.vue';
  import RTLLayout from '@/layout/direction/RTLLayout.vue';
  import KTFooter from '@/layout/footer/Footer.vue';
  import firebase from './firebase';
  import { getAnalytics, logEvent } from 'firebase/analytics';

  export default defineComponent({
    name: 'app',
    data() {
      return {
        isRtl: false,
        loaded: false,
      };
    },
    computed: {
      animation() {
        return {
          /**
           * Animation function
           *
           * Runs before animating, so you can take the initial height, width, color, etc
           * @param  {HTMLElement}  element  The notification element
           */
          enter(element) {
            let height = element.clientHeight;
            return {
              // animates from 0px to "height"
              height: [height, 0],

              // animates from 0 to random opacity (in range between 0.5 and 1)
              opacity: [Math.random() * 0.5 + 0.5, 0],
            };
          },
          leave: {
            height: 0,
            opacity: 0,
          },
        };
      },
    },
    mounted() {
      const vm = this;
      if (localStorage.getItem('lang') == 'en') {
        //LTR version styles
        document.documentElement.removeAttribute('direction');
        document.documentElement.removeAttribute('dir');
        document.documentElement.setAttribute('lang', 'en');
        document.documentElement.style.direction = 'ltr';
        localStorage.setItem('lang', 'en');
        // document.querySelectorAll('[data-kt-menu-placement="bottom-start"]')[0].setAttribute('data-kt-menu-placement','bottom-end')
        // document.querySelectorAll('[data-kt-menu-placement="right-start"]')[0].setAttribute('data-kt-menu-placement','left-end')
        this.isRtl = false;
      } else {
        //RTL version styles
        document.documentElement.setAttribute('direction', 'rtl');
        document.documentElement.setAttribute('dir', 'rtl');
        document.documentElement.setAttribute('lang', 'ar');
        document.documentElement.style.direction = 'rtl';
        localStorage.setItem('lang', 'ar');
        this.isRtl = true;
      }
      setTimeout(() => {
        vm.loaded = true;
      }, 1000);
    },
    components: {
      LTRLayout, RTLLayout, KTFooter,
    },
    setup() {
      const store = useStore();
      const route: any = useRoute();

      onMounted(() => {
        // Initialize Firebase
        const analytics = getAnalytics(firebase);
        watch(() => route.name, () => {
          if (route && route.name) {
            logEvent(analytics, 'page_view', {
              page_title: route.name,
              type: 'internal',
            });
          }
        }, { immediate: true });
        /**
         * this is to override the layout config using saved data from localStorage
         * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
         */
        store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

        store.dispatch('moduleCommon/getSiteConfig', {});
        store.dispatch('moduleCommon/getLookups', {});
      });
    },
  });
